<template>
  <div class="myCard">
    <header-info-card
      :task="task"
      :editMode="editMode"
      @taskEdit="openEdit(task)"
      @close="close()"
      v-if="alone"
    ></header-info-card>
    <div class="infos-view">
      <div class="employee-city">
        <div class="line employee">
          <div class="field">
            {{ $t("editEventCard.employee") }}
          </div>
          <div class="data">
            {{ task.employee }}
          </div>
        </div>
      </div>
      <div class="dates-times">
        <div class="line dates">
          <div class="field">
            {{ $t("editEventCard.date") }}
          </div>
          <div class="data">
            <div class="data">
              {{ $t("editEventCard.from") }}
              {{ task.x }}
            </div>
            <div class="data">
              {{ $t("editEventCard.to") }}
              {{ task.dateEnd }}
            </div>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="field">
          {{ $t("editEventCard.Intervention") }}
        </div>
        <div v-if="task.details.intervention" class="data">
          {{task.details.intervention.dateStart }} - {{ task.details.intervention.course.title }}
        </div>
        <div v-else class="data">
          {{ $t("editEventCard.noIntervention") }}
        </div>
      </div>
      <div class="line">
        <div class="field">
          {{ $t("editEventCard.duration") }}
        </div>
        <div v-if="task.duration" class="data">
          {{ task.duration }}
          {{
            task.duration > 1
              ? $t("editEventCard.durationMultipleDays")
              : $t("editEventCard.durationSingleDay")
          }}
        </div>
      </div>
      <div class="line">
        <div class="field">
          {{ $t("taskInfoCard.linkField") }}
        </div>
        <div class="data">
          <p class="link" v-on:click="redirectToDawanOrg()">
            {{ $t("taskInfoCard.linkToDg2") }}
          </p>
        </div>
      </div>
      <div class="slug">
        <div class="field">
          {{ $t("taskInfoCard.Slug") }}
        </div>
        <div v-if="task.slug" class="data">
          {{ task.slug }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerInfoCard from "./headerInfoCard.vue";
import Links from "@/models/Links"

export default {
  components: { headerInfoCard },
  name: "view-event-info",
  props: {
    linkedIntervention: {},
    users: [],
    task: {
      y: null,
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      eventSiblings: [],
    },
    alone: false,
    editMode: null,
    // dg2UrlRedirect : "
  },
  data() {
    return {
      Links: Links,
    };
  },
  methods: {
    redirectToDawanOrg() {
      window.open(Links.DawanOrgShowTask(this.task.slug));
    },
    openEdit(task) {
      this.$emit("openEditTaskDialog", task);
    },
    close(){
      this.$emit("closeCard");
    }
  },
};
</script>

<style lang="scss">
.infos-view {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;
  overflow-y: scroll;

  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .field {
    color: rgb(155, 155, 155);
  }
  .data {
    text-align: right;
  }

  .slug {
    text-align: justify;
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .link {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
